import { render, staticRenderFns } from "./MenuOverlay.vue?vue&type=template&id=43280aed&scoped=true&"
import script from "./MenuOverlay.vue?vue&type=script&lang=js&"
export * from "./MenuOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MenuOverlay.vue?vue&type=style&index=0&id=43280aed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43280aed",
  null
  
)

export default component.exports